// extracted by mini-css-extract-plugin
export default {"ag-styles":"X_g","container":"X_h","quoteBubbleTail":"X_fD","orgContainer":"X_fF","avatar":"X_fG","name":"X_fr","orgIcon":"X_fH"};